import { type IOverviewJointBillService } from "@services/overview/types";
import { api, apiV3 } from "@/api";
import type { IAddNonProfitProviderParams, INonProfitProvider } from "./types";

export const getNonProfitProviders = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  api
    .get<{ providers: INonProfitProvider[] }>(`/nonprofits`, {
      headers: {
        jointBillServiceId,
      },
    })
    .then((r) => r.data?.providers ?? []);

export const hideNonProfitProviders = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  api
    .delete<{ providers: INonProfitProvider[] }>(`/nonprofits/advertisements`, {
      headers: {
        jointBillServiceId,
      },
    })
    .then((r) => r.data?.providers ?? []);

export const addNonProfitProvider = (params: IAddNonProfitProviderParams) =>
  apiV3.post<{ providers: INonProfitProvider[] }>(
    `/nonprofits/joint-bill-service-agreements`,
    {
      serviceProviderId: params.serviceProviderId,
      amount: params.amount,
      personalCode: params.personalCode,
      periodId: params.periodId,
    },
    {
      headers: {
        jointBillServiceId: params.jointBillServiceId,
      },
    },
  );
